export default __webpack_public_path__ + "static/media/newsfeed_search.78cf69fb.png";